import { PreguntaCargaDTO } from "@DTOS";
import { MultipleSubtipoEnum, PreguntasTipoEnum } from "@shared/enums";
import { DatosPreguntaImportador } from "../DatosPreguntaImportador";
import { PREGUNTA_PADRE } from "../constantesImportador";
import { PreguntaImportador } from "../PreguntaImportador";

export class PreguntaSiNoImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.SIYNO;
    }

    public procesar(datos: DatosPreguntaImportador[]): PreguntaCargaDTO[] {
        const preguntas = super.procesar(datos);
        const preguntaPadre = preguntas[PREGUNTA_PADRE];
        preguntaPadre.tipo = PreguntasTipoEnum.MULTIPLE_CHOICE;
        preguntaPadre.subtipo = MultipleSubtipoEnum.YESNO;
        return preguntas;
    }
}
